export default "__VITE_ASSET__dcf562d1__"